// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface TableResourcesListTableRoleAssignmentsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableResourcesDeleteTableRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesCreateUpdateTableRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesGetTableRoleAssignmentOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableResourcesListTableRoleDefinitionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableResourcesDeleteTableRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesCreateUpdateTableRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesGetTableRoleDefinitionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableResourcesRetrieveContinuousBackupInformationOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesListTablesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableResourcesDeleteTableOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesCreateUpdateTableOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesGetTableOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableResourcesMigrateTableToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesMigrateTableToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesUpdateTableThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface TableResourcesGetTableThroughputOptionalParams extends OperationOptions {}
